/* eslint-disable */
import { SEND_UNIQUE_CODE_TO_USER } from 'store/actions/actionTypes';

export const sendUniqueCodeToUser = () => ({
  type: SEND_UNIQUE_CODE_TO_USER,
});